import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      required: true
    },
    from: {
      type: Number,
      default: 0
    },
    to: {
      type: Number,
      default: 0
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localValue: {
      get: function get() {
        return this.value | this.from;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {
    from: function from() {
      this.fromTo();
    },
    to: function to() {
      this.fromTo();
    }
  },
  data: function data() {
    return {
      options: this.fromTo()
    };
  },
  methods: {
    fromTo: function fromTo() {
      var options = [];

      for (var i = this.from; i <= this.to; i++) {
        options.push({
          value: i,
          label: i.toString()
        });
      }

      this.model = this.model || options[0].label;
      return options;
    }
  }
};